module.exports = __webpack_public_path__ + "img/6-1.77199c86.png";